export default __webpack_public_path__ + "static/media/spectrophotometer-info-6.138b0412.svg";